import React, { useState, useEffect } from 'react';
import { updateCapitaleCantiere } from '../../services/cantieriService';

const formatEuro = (val) =>
  Number(val || 0).toLocaleString('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

export default function Topbar({ projectName, capitaleInvestito, cantiereId, onCapitaleUpdated }) {
  const [editing, setEditing] = useState(false);
  const [capitale, setCapitale] = useState(capitaleInvestito);

  useEffect(() => {
    setCapitale(capitaleInvestito);
  }, [capitaleInvestito]);
  const handleToggleSidebar = () => {
    const sidebar = document.querySelector('.sidebar');
    const mainContent = document.getElementById('main-content');
    if (sidebar) {
      sidebar.classList.toggle('collapsed');
    }
    if (mainContent) {
      const collapsed = sidebar && sidebar.classList.contains('collapsed');
      mainContent.style.marginLeft = collapsed ? '80px' : '320px';
    }
  };

  const handleSave = async () => {
    try {
      const valore = parseFloat(capitale);
      await updateCapitaleCantiere(cantiereId, valore);
      onCapitaleUpdated && onCapitaleUpdated(valore);
    } catch (err) {
      console.error('Errore salvataggio capitale', err);
    }
    setEditing(false);
  };

  const displayVal =
    capitaleInvestito === 1 ? 'Inserisci capitale' : formatEuro(capitaleInvestito);
  const btnLabel = capitaleInvestito === 1 ? 'Inserisci' : 'Modifica';

  return (
    <section className="topbar">
      <div className="topbar-row">
        <div className="left">
          <button
            className="sidebar-toggle"
            aria-label="Apri o chiudi la sidebar"
            onClick={handleToggleSidebar}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <h2>Progetto "{projectName}"</h2>
        </div>
        <div className="right">
          {editing ? (
            <>
              <input
                type="number"
                className="form-control"
                value={capitale === 1 ? '' : capitale}
                onChange={(e) => setCapitale(e.target.value)}
              />
              <button className="btn btn-primary" onClick={handleSave}>
                Salva
              </button>
            </>
          ) : (
            <>
              <span>Capitale investito: {displayVal}</span>
              <button
                className="btn btn-outline-secondary btn-sm ms-2"
                onClick={() => setEditing(true)}
              >
                {btnLabel}
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
